import { motion } from 'framer-motion';

export default function ServicesHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 pt-16 sm:pt-20 lg:pt-24 pb-8 sm:pb-12 lg:pb-16 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-5 sm:top-10 lg:top-20 right-5 sm:right-10 lg:right-20 w-20 h-20 sm:w-40 sm:h-40 lg:w-64 lg:h-64 bg-gradient-to-br from-emerald-500/20 to-transparent rounded-full blur-xl sm:blur-2xl"></div>
        <div className="absolute bottom-5 sm:bottom-10 lg:bottom-20 left-5 sm:left-10 lg:left-20 w-20 h-20 sm:w-40 sm:h-40 lg:w-64 lg:h-64 bg-gradient-to-br from-teal-500/20 to-transparent rounded-full blur-xl sm:blur-2xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 text-center relative z-10">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-block text-xs sm:text-sm font-semibold text-emerald-400 tracking-wider uppercase mb-2 sm:mb-3 lg:mb-4 px-3 py-1.5 sm:px-4 sm:py-2 bg-emerald-500/10 rounded-full border border-emerald-500/30"
        >
          Solutions complètes
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4 lg:mb-6 leading-tight"
        >
          Un accompagnement{" "}
          <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
            360° sur mesure
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-sm sm:text-base text-slate-300 mb-6 sm:mb-8 lg:mb-10 max-w-3xl mx-auto leading-relaxed"
        >
          De l'audit énergétique à l'installation complète, nous vous accompagnons dans votre projet de rénovation LED industrielle avec une expertise certifiée.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-xs sm:text-sm text-emerald-400 font-medium"
        >
          ✓ Intervention sur toute la France • Financement CEE disponible
        </motion.div>
      </div>
    </section>
  );
}
